<div class="container">
  <div class="items">
    <div *ngFor="let item of items; trackBy: trackBy"
         class="item"
         [class.disabled]="disabled"
         [class.active]="value === item.value"
         (click)="onItemClick(item)">
      <ppl-svg-icon [icon]="item.icon"
                    width="20"
                    height="20"></ppl-svg-icon>
      <span>{{ item.label }}</span>
    </div>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>